// extracted by mini-css-extract-plugin
export default {"scheduleLabel":"ScheduleLabel_scheduleLabel__v1G-q"};